var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66602 9.99984C1.66602 5.39984 5.39935 1.6665 9.99935 1.6665C14.5993 1.6665 18.3327 5.39984 18.3327 9.99984C18.3327 14.5998 14.5993 18.3332 9.99935 18.3332C5.39935 18.3332 1.66602 14.5998 1.66602 9.99984ZM10.8327 13.3332V14.9998H9.16602V13.3332H10.8327ZM9.99935 16.6665C6.32435 16.6665 3.33268 13.6748 3.33268 9.99984C3.33268 6.32484 6.32435 3.33317 9.99935 3.33317C13.6743 3.33317 16.666 6.32484 16.666 9.99984C16.666 13.6748 13.6743 16.6665 9.99935 16.6665ZM6.66602 8.33317C6.66602 6.4915 8.15768 4.99984 9.99935 4.99984C11.841 4.99984 13.3327 6.4915 13.3327 8.33317C13.3327 9.40227 12.6743 9.9776 12.0333 10.5378C11.4252 11.0692 10.8327 11.587 10.8327 12.4998H9.16602C9.16602 10.9821 9.95111 10.3803 10.6414 9.85123C11.1829 9.43618 11.666 9.06585 11.666 8.33317C11.666 7.4165 10.916 6.6665 9.99935 6.6665C9.08268 6.6665 8.33268 7.4165 8.33268 8.33317H6.66602Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpOutline);
export default __webpack_public_path__ + "static/media/help-outline.1ab6674ebc8da1be53104c278ca54daf.svg";
export { ForwardRef as ReactComponent };